<template>
    <div class="mt16 pl16" v-if="show">
		<div class="df">
			<div class="contract-name mr24" style="width: 342px;">
				<input-styled
	                    name="title"
	                    :auto-focus="true"
	                    :placeholder="'НАЗВАНИЕ ДОГОВОРА'"
	                    :placeholderInput="'НАЗВАНИЕ ДОГОВОРА'"
	                    v-model="form.title.value"
                        @input="setIsEdit()"
	                    :maxLengthNum="20"
                        ref="title"
	                    @focus="form.title.error=false"
	                    :is-error="form.title.error">
	            </input-styled>
			</div>
			<div class="text-size-s">
				Название договора должно быть уникальным<br>
				и содержать не более 20 символов
			</div>
		</div>
        <div id="contract-body" class="contract-body  pseudo-textarea mt16" :class="{'pseudo-textarea--focus':contractFocus}">
            <h1 class="text-center mb10 mt0">ДОГОВОР</h1>
            <div class="df df--center">
                <input @input="setIsEdit()" @focus="focusContract()" @blur="blurContract()" v-model="contractData.type.value" type="text" placeholder="укажите тип договора" class="inp-size-28 text-center full">
            </div>
            <div class="text-size-16 df df--space-between mb20 mt20">
                <input @input="setIsEdit()" @focus="focusContract()" @blur="blurContract()" v-model="contractData.city.value" type="text" placeholder="Укажите город " class="text-bold" style="width: 371px">
                <span>«____»_____________20___г</span>
            </div>
            <editable-item @input="setIsEdit()" :auto-focus="autofocus" v-model="contractData.text.value" @focus="focusContract(false, false, $event)" @blur="blurContract()"/>
            <div :key="'section'+section.number" class="contract-sections" v-for="(section,sectionIndex) in contractData.sections">
                <h2 class="text-center mt20 mb20 df df--center">{{section.number}}. <editable-item-simple @next="focusByRef('olItem0'+sectionIndex)" @input="setIsEdit()" :ref="'sectionTitle'+sectionIndex" @keydown.native.delete="deleteSection(sectionIndex)" v-model="section.title" @focus="focusContract(section)" @blur="blurContract()" placeholder="ВВЕДИТЕ ЗАГОЛОВОК" class="w-auto text-uppercase"/></h2>
                <div :key="'section'+itemIndex" v-for="(item,itemIndex) in section.items">
                    <ol v-if="item.type === 'ol'">
                        <li :key="'olItem'+indexOL+sectionIndex" v-for="(olItem,indexOL) in item.items">
							<span class="number">{{section.number}}.{{+indexOL + 1}}</span>
							<div class="flex">
	                            <editable-item :key="'olItemF'+indexOL+sectionIndex"
                                               :ref="'olItem'+indexOL+sectionIndex"
                                               v-model="olItem.text"
                                               @input="setIsEdit()"
                                               :auto-focus="autofocus"
                                               :no-break="true"
                                               @focus="focusContractOl(olItem,indexOL,section,$event)"
                                               @blur="blurContract()"
                                               @delete="deleteItemOl(item,indexOL,'olItem'+(+indexOL-1)+sectionIndex,'sectionTitle'+sectionIndex)"
                                               @push="pushItemOl(item,indexOL,'olItem'+(+indexOL+1)+sectionIndex)"/>
								<ul v-if="olItem.child[0]">
									<li :key="'ulItem'+indexUl+indexOL+sectionIndex" v-for="(ulItem,indexUl) in olItem.child[0].items">
                                        <editable-item :no-break="true" :key="'ulItemF'+indexUl+indexOL+sectionIndex"
                                             :ref="'ulItem'+indexUl+indexOL+sectionIndex"
                                             :auto-focus="autofocus"
                                             v-model="ulItem.text"
                                             @input="setIsEdit()"
                                             @focus="focusContractUl(ulItem,indexOL,indexUl,section, $event)"
                                             @blur="blurContract()"
                                             @delete="deleteItemUL(olItem.child[0].items,indexUl,'ulItem'+(+indexUl-1)+indexOL+sectionIndex,'olItem'+(+indexOL)+sectionIndex)"
                                             @push="pushItemUL(olItem.child[0].items,indexUl,'ulItem'+(+indexUl+1)+indexOL+sectionIndex)"/>
                                    </li>
								</ul>
							</div>
                        </li>
                    </ol>
                </div>
            </div>

        </div>
        <h2 class="text-center mt16 text-size-ml">{{ contractData.sections.length + 1 }}. РЕКВИЗИТЫ И ПОДПИСИ СТОРОН</h2>
        <div class="df df--space-between df--align-start signatures mt20">
            <div>
                <editable-item :auto-focus="false" @focus="setEditor(false)" show-bar="true" bar-title="ЗАКАЗЧИК" v-model="contractData.customer.value" placeholder="Реквизиты заказчика"/>
                <div class="mt24"><file-upload
                        v-model="form.sign.value"
                        :accept-type="'image/png'"
                        :action-delete="''"
                        @input="setIsEdit()"
                        @upload="$emit('disableSave',$event || form.stamp.upload);form.sign.upload = $event;"
                        :action-send="'contracts/uploadImage'"
                        :operation="'uploadSign'"
						:maxWidth="{'width': 300 + 'px'}"
                        :btnText="'Загрузить факсимиле'">
                </file-upload> </div>
            </div>
            <div>
                <editable-item :auto-focus="false" @focus="setEditor(false)"  show-bar="true" bar-title="ИСПОЛНИТЕЛЬ" v-model="contractData.executor.value" placeholder="Реквизиты исполнителя"/>
                <div class="mt24"><file-upload
                        v-model="form.stamp.value"
                        :accept-type="'image/png'"
                        :action-delete="''"
                        @input="setIsEdit()"
                        @upload="$emit('disableSave',$event || form.sign.upload);form.stamp.upload = $event;"
                        :action-send="'contracts/uploadImage'"
                        :operation="'uploadStamp'"
						:maxWidth="{'width': 300 + 'px'}"
                        :btnText="'Загрузить печать'">
                </file-upload> </div>
            </div>
        </div>
        <div class="checkbox" style="margin-top: 28px;">
            <input @input="setIsEdit()" v-model="contractData.hideRequisites.value" type="checkbox" id="hideRequisites" name="hideRequisites">
            <label for="hideRequisites">Скрывать реквизиты заказчика на этапе ознакомления  с договором</label>
        </div>
        <history v-if="contractDetail.id" :contractDetail="contractDetail"></history>
        <popup @close="previewLink = '';" :is-set-styled="false" :show="popups.previewPDFNew.show" :name="popups.previewPDFNew.name" :width="940" :add-class="'contract-preview'">
            <iframe v-if="popups.previewPDFNew.show && previewLink" width="840" height="1200" :src="previewLink" frameborder="0"></iframe>
        </popup>
        <popup :is-set-styled="false" :show="popups.moveContract.show" :name="popups.moveContract.name" :width="512" >
            <move-contract @move="save(false)" :newSection="contractsGroupedCurrentIndex" :oldSection="contractDetail.group"></move-contract>
        </popup>
    </div>
</template>

<script>
import InputStyled from '@/components/forms/InputStyled.vue';
import EditableItem from '@/components/contract/EditableItem.vue';
import EditableItemSimple from '@/components/contract/EditableItemSimple.vue';
import History from '@/components/contract/History';
import Popup from '@/components/modal/Popup.vue';
import Tooltip from '@/components/Tooltip.vue';
import FileUpload from '@/components/forms/FileUpload.vue';
import MoveContract from '@/components/modal/rules/MoveContract.vue';

import {mapState} from "vuex";

export default {
    name: "ContractEditor",
    components: {
        InputStyled,
        EditableItem,
        Popup,
        EditableItemSimple,
        Tooltip,
        History,
		FileUpload,
        MoveContract,
    },
    props: {
        contractDetail: {},
        group: 0
    },
    data(){
        return {
            logActive: false,
            show: false,
            form: {
                title: {
                    value: '',
                    error: false,
                },
                stamp: {
                    value: '',
                    error: false,
                    upload: false,
                },
                sign: {
                    value: '',
                    error: false,
                    upload: false,
                },
            },
            showSections: true,
            focusItem: {},
            autofocus: false,
            focusSection: 1,
            focusOlItem: 0,
            focusUlItem: 0,
            previewLink: '',
            contractData: {
                id: false,
                type: {
                    value: ''
                },
                city: {
                    value: ''
                },
                text: {
                    value: ''
                },
                sections: [
                    {
                        number: 1,
                        title: '',
                        type: 'section',
                        items: [
                            {
                                type: 'ol',
                                items: [
                                    {
                                        text: '',
                                        type: 'olItem',
                                        child: []
                                    }
                                ]
                            }
                        ]
                    }
                ],
                customer: {
                    value: ''
                },
                executor:  {
                    value: ''
                },
                hideRequisites:  {
                    value: ''
                },
            },
            contractFocus: false,
        }
    },
    computed: {
        ...mapState({
            popups: state => state.popups.items,
        }),
        contractsGroupedCurrentIndex(){
            return  this.$route.params.sid ? this.$route.params.sid : 0
        },
    },
    mounted() {
        if(this.contractDetail.id){
            this.form.title.value = this.contractDetail.title;
            this.contractData.id = this.contractDetail.id;
            this.contractData.type.value = this.contractDetail.type;
            this.contractData.city.value = this.contractDetail.city;
            this.contractData.text.value = this.contractDetail.text;
            this.form.sign.value = this.contractDetail.sign;
            this.form.stamp.value = this.contractDetail.stamp;
            this.contractData.text.value = this.contractDetail.text;
            this.contractData.sections = this.contractDetail.sections;
            this.contractData.customer.value = this.contractDetail.customer;
            this.contractData.executor.value = this.contractDetail.executor;
            this.contractData.hideRequisites.value = +this.contractDetail.hideRequisites === 1;
            this.$store.dispatch('contracts/setTimerBlockEdit', {id: this.contractDetail.id});
        }
        this.show = true;
        if(this.$refs['title']){
            this.$refs['title'].inputFocus('field');
        }
        setTimeout(()=>{
            this.autofocus = true;
            this.$emit('is_edit',false)
        },50)
    },
    beforeDestroy() {
        this.$store.dispatch('contracts/clearBlockEdit', {id: this.contractDetail.id});
    },
    methods: {
        focusContract(item,section,event) {
            this.contractFocus = true;
            this.focusItem = item ? item : {}
            this.focusSection = section ? section.number : 1;
            this.focusOlItem = 0;
            this.focusUlItem = 0;
            if(event){
                this.$emit('editor',event);
            }
        },
        focusContractOl(item,index,section,event) {
            this.contractFocus = true;
            this.focusItem = item ? item : {}
            this.focusOlItem = index ? index : 0;
            this.focusUlItem = 0;
            this.focusSection = section ? section.number : 1;
            if(event){
                this.$emit('editor',event);
            }
        },
        focusContractUl(item,indexOl,index,section,event) {
            this.contractFocus = true;
            this.focusItem = item ? item : {}
            this.focusOlItem = indexOl ? indexOl : 0;
            this.focusUlItem = index ? index : 0;
            this.focusSection = section ? section.number : 1;
            if(event){
                this.$emit('editor',event);
            }
        },
        setEditor(event){
            this.$emit('editor',event);
        },
        blurContract(){
            this.contractFocus = false;
            //this.$emit('contract',false);
        },
        bold(){

        },
        pushItemOl(item,indexOL,ref){
            item.items.splice(+indexOL+1,0,{text: '',type: 'olItem',child: []})
            this.updateAllText();
            this.$nextTick(()=>{
                if(this.$refs[ref] && this.$refs[ref][0].setFocus){
                    this.$refs[ref][0].setFocus()
                }
            })
        },
        deleteItemOl(item,indexOL,ref,refParent){
            if(item.items.length > 0){
                item.items.splice(+indexOL,1)
                this.updateAllText();
            }
            this.$nextTick(()=>{
                if(this.$refs[ref] && this.$refs[ref][0].setFocus){
                    this.$refs[ref][0].setFocus()
                } else if(this.$refs[refParent] && this.$refs[refParent][0].inputFocus){
                    this.$refs[refParent][0].inputFocus()
                }
            })
        },
        pushItemUL(items,indexUl,ref){
            items.splice(+indexUl+1,0,{text: '',type: 'ulItem'})
            this.updateAllText();
            this.$nextTick(()=>{
                if(this.$refs[ref] && this.$refs[ref][0].setFocus){
                    this.$refs[ref][0].setFocus()
                }
            })
        },
        deleteItemUL(items,indexUl,ref,refParent){
            items.splice(+indexUl,1)
            this.updateAllText();
            this.$nextTick(()=>{
                if(this.$refs[ref] && this.$refs[ref][0].setFocus){
                    this.$refs[ref][0].setFocus()
                } else if(this.$refs[refParent] && this.$refs[refParent][0].setFocus){
                    this.$refs[refParent][0].setFocus()
                }
            })
        },
        updateAllText(){
            for(let i in this.$refs){
                if(this.$refs[i][0] && this.$refs[i][0].updateContent) {
                    this.$refs[i][0].updateContent();
                }
            }
        },
        deleteSection(index){
            if(this.contractData.sections.length > 1 && this.contractData.sections[index].items[0].items.length == 0 && this.contractData.sections[index].title.length == 0){
                this.contractData.sections.splice(+index,1)
            }
            for(let s in this.contractData.sections){
                this.contractData.sections[s].number = +s+1
            }
            this.updateAllText();
        },
        pushOL(){
            if(typeof this.focusItem  == 'object' && this.focusItem.type === 'section') {
                let isOL = false;
                if(this.focusItem.items[this.focusItem.items.length-1].type === 'ol'){
                    isOL = true;
                }
                if(!isOL){
                    for(let s in this.contractData.sections){
                        if(this.contractData.sections[s].number == this.focusItem.number){
                            this.contractData.sections[s].items.push({
                                type: 'ol',
                                    items: [
                                    {
                                        text: '',
                                        type: 'olItem',
                                        child: []
                                    }
                                ]
                            });
                        }
                    }
                }
                if(isOL && this.focusItem.items[this.focusItem.items.length-1].items.length == 0){
                    this.focusItem.items[this.focusItem.items.length-1].items.push({
                        text: '',
                        type: 'olItem',
                        child: []
                    })
                }
            }
            if(typeof this.focusItem  == 'object' && this.focusItem.type === 'olItem') {
                this.contractData.sections[this.focusSection-1].items[0].items.splice(+this.focusOlItem,0,{
                    text: '',
                    type: 'olItem',
                    child: []
                });
                this.updateAllText();
            }
            this.focusItem = {};
        },
        pushUL(){
            if(typeof this.focusItem  == 'object' && this.focusItem.type === 'olItem') {
                let isUL = false;
                if(this.focusItem.child.length && this.focusItem.child[this.focusItem.child.length-1].type === 'ul'){
                    isUL = true;
                }
                if(!isUL){
                    for(let s in this.contractData.sections){
                        if(this.contractData.sections[s].number == this.focusSection){
                            for(let i in this.contractData.sections[s].items){
                                if(this.contractData.sections[s].items[i].type === 'ol' && this.contractData.sections[s].items[i].items[this.focusOlItem]){
                                    this.contractData.sections[s].items[i].items[this.focusOlItem].child.push({
                                        type: 'ul',
                                        items: [
                                            {
                                                text: '',
                                                type: 'ulItem',
                                            }
                                        ]
                                    });
                                }
                            }

                        }
                    }
                }
                if(isUL && this.focusItem.type === 'olItem'){
                    this.focusItem.child[this.focusItem.child.length-1].items.push({
                        text: '',
                        type: 'ulItem',
                    })
                }
                this.updateAllText();
            } else if(this.focusItem.type === 'ulItem'){
                this.contractData.sections[(this.focusSection-1)].items[0].items[this.focusOlItem].child[0].items.splice(this.focusUlItem+1,0,{
                    text: '',
                    type: 'ulItem',
                });
                this.updateAllText();
            }
            this.focusItem = {};
        },
        pushSection(){
            this.contractData.sections.splice(this.focusSection,0,{
                number: this.contractData.sections.length + 1,
                title: '',
                type: 'section',
                items: [
                    {
                        type: 'ol',
                        items: [
                            {
                                text: '',
                                type: 'olItem',
                                child: []
                            }
                        ]
                    }
                ]
            });
            for(let s in this.contractData.sections){
                this.contractData.sections[s].number = +s+1
            }
            this.updateAllText();
            this.focusItem = {};
        },
        save(checkMoveSection){
            let error = false;
            if(+this.form.title.value.length === 0){
                if (this.form.title.error) {
                    this.form.title.error = false;
                    setTimeout(() => {
                        this.form.title.error = true;
                    }, 10);
                } else {
                    this.form.title.error = true;
                }
                error = true;
            }
            if(checkMoveSection && this.contractData.id && this.contractsGroupedCurrentIndex != this.contractDetail.group){
                this.$store.dispatch('popups/open', {name: this.popups.moveContract.name});
                error = true;
            }
            if(!error){
                this.$emit('load');
                this.form.btnType = 'load';
                let params = {
                    id: this.contractData.id ? this.contractData.id : false,
                    group: this.contractData.group,
                    form:{
                        operation: this.contractData.id ? 'update': 'add',
                        type: this.contractData.type.value,
                        city: this.contractData.city.value,
                        text: this.contractData.text.value,
                        sections: JSON.stringify(this.contractData.sections),
                        customer: this.contractData.customer.value,
                        executor: this.contractData.executor.value,
                        hideRequisites: this.contractData.hideRequisites.value ? 1 : 0,
                        title: this.form.title.value,
                        sign: JSON.stringify(this.form.sign.value),
                        stamp: JSON.stringify(this.form.stamp.value),
                        group: this.contractsGroupedCurrentIndex,
                    }
                };

                this.$store.dispatch('contracts/save', params).then((result)=>{
                    this.$emit('save',result);
                    if(this.$route.params.id == 'new'){
                        this.$router.push('/staff/contract/'+result.group+'/'+result.id+'/')
                    }
                    if(this.contractsGroupedCurrentIndex != this.contractDetail.group || this.$route.params.id == 'new'){
                        this.$store.dispatch('contracts/getItems')
                    }
                });
            }
        },
        preview(){
            let params = {
                form:{
                    operation: 'preview',
                    type: this.contractData.type.value,
                    city: this.contractData.city.value,
                    text: this.contractData.text.value,
                    sections: JSON.stringify(this.contractData.sections),
                    customer: this.contractData.customer.value,
                    executor: this.contractData.executor.value,
                    hideRequisites: this.contractData.hideRequisites.value ? 1 : 0,
                    title: this.form.title.value,
                }
            };

            this.$store.dispatch('contracts/preview', params).then((result)=>{
                this.previewLink = result;
                this.$store.dispatch('popups/open', {name: this.popups.previewPDFNew.name});
            });
        },
        setIsEdit(){
            this.$emit('is_edit',true)
        },
        focusByRef(ref){
            if(this.$refs[ref] && this.$refs[ref][0].setFocus){
                this.$refs[ref][0].setFocus()
            }
        }
    }
}
</script>

<style scoped>
    .pseudo-textarea--focus{
        background-color: #fff;
        border-color: #2F80ED;
    }
</style>
